// ======================================================================
// File Name       : ContentDocumentEditContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Button, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { reduxForm } from 'redux-form';
import { editDocumentDetail, getDocumentDetail } from '../../actions/content/ContentDocumentAction';
import ContentDocumentConfirmDialog from '../../components/content/ContentDocumentConfirmDialog';
import ContentDocumentEditRegister from '../../components/content/ContentDocumentEditRegister';
import Header from '../../components/Header';
import { DOCUMENT_EDIT_TYPE } from '../../constants/ContentConstant';
import { showLoading } from '../../utils/PageUtils';
import CustomLink from '../../components/button/CustomLink';
import * as Path from '../../constants/PathConstants';

class ContentDocumentEditContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editSuccess: false,
      showDialogConfirm: false,
    };
    this.sendEditRequest = this.sendEditRequest.bind(this);
    this.handleOKButton = this.handleOKButton.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  componentWillMount() {
    const { match } = this.props;
    if (match.params.id) {
      const contentSecernId = match.params.id;
      const params = {};
      params.selectTargetData = 0;
      params.searchInfo = {
        contentSecernIdList: [contentSecernId],
      };
      this.props.dispatch(getDocumentDetail(params));
    }
  }

  handleOKButton() {
    if (this.props.valid) {
      this.setState({ showDialogConfirm: true });
    }
  }

  handleCancelClick() {
    this.setState({ showDialogConfirm: false });
  }

  sendEditRequest() {
    this.setState({ showDialogConfirm: false });
    const { valid, documentEditForm } = this.props;
    if (documentEditForm && documentEditForm.values && valid) {
      const params = {};
      params.editType = DOCUMENT_EDIT_TYPE.UPDATE;
      const documentDetail = {};
      documentDetail.contentSecernId = documentEditForm.values.contentSecernId;
      documentDetail.contentName = documentEditForm.values.contentName;
      params.documentContentInfo = documentDetail;
      if (documentEditForm.values.uploadFile) {
        params.uploadFile = documentEditForm.values.uploadFile[0];
      }
      this.props.dispatch(showLoading());
      this.props.dispatch(editDocumentDetail(params));
    }
  }

  goBack() {
    this.props.history.goBack();
  }

  render() {
    const { documentContentInfo, editSuccess } = this.props;
    if (!documentContentInfo || editSuccess) {
      return <Redirect to={Path.CONTENT_DOCUMENT_LIST} />;
    }
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.CONTENT_DOCUMENT_LIST}
          text="ドキュメント一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="ドキュメントの編集" />
        <ContentDocumentEditRegister {...documentContentInfo} isEdit />
        <Col sm={12} className="text-center margin-top-20">
          <Button variant="default" className="btn btn-default btn-96 margin-10" onClick={this.goBack}>
            キャンセル
          </Button>
          <Button
            variant="primary"
            className="btn-96 margin-10"
            onClick={this.props.handleSubmit(this.handleOKButton)}
          >
            OK
          </Button>
        </Col>
        <ContentDocumentConfirmDialog
          showModal={this.state.showDialogConfirm}
          handleOkClick={this.sendEditRequest}
          handleCancelClick={this.handleCancelClick}
          documentData={documentContentInfo}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { editSuccess } = state.document;
  let { documentContentInfo } = state.document;
  const { documentEditForm } = state.form;
  let documentContentDetail = { ...documentContentInfo };
  if (documentEditForm && documentEditForm.values) {
    documentContentDetail = { ...documentEditForm.values };
    if (documentEditForm.values.uploadFile && documentEditForm.values.uploadFile.length) {
      documentContentDetail.documentName = documentEditForm.values.uploadFile[0].name;
      documentContentDetail.documentSize = documentEditForm.values.uploadFile[0].size;
    }
  }
  documentContentInfo = documentContentDetail;
  return {
    ...{ documentContentInfo },
    ...{ documentEditForm },
    initialValues: documentContentInfo,
    editSuccess,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'documentEditForm',
    enableReinitialize: true,
    touchOnChange: true,
  })(ContentDocumentEditContainer),
);
